<div class="map-slider-wrapper" >

  <!-- 🔹 Barra superior fija -->
  <div class="map-slider-header d-flex justify-content-between align-items-center py-2 border-bottom bg-white shadow-sm">
    <!-- Botón para ocultar -->
    <button class="btn btn-sm btn-light d-flex align-items-center gap-2" (click)="toggleSlider()">
      <i class="pi" [ngClass]="'pi-angle-right'"></i>
    </button>

    <!-- Buscador -->
    <span class="p-input-icon-left flex-grow-1">
      <i class="pi pi-search"></i>
      <input
        type="text"
        pInputText
        placeholder="Buscar por mapa o vehículo"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange($event)"
        class="w-100"
      />
    </span>
  </div>

  <!-- 🔹 Mensaje de carga -->
  <div *ngIf="!originalMaps?.length" class="loading-message text-center py-4">
    <i class="pi pi-spin pi-spinner"></i> Cargando mapas...
  </div>

  <!-- 🔹 Contenido de mapas -->
  <div *ngIf="originalMaps?.length" class="tree-groups overflow-auto" style="max-height: calc(100vh - 70px)">
    <div *ngFor="let map of maps; trackBy: trackByMap">
      <div class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom tree_section" (click)="clickGroup(map)">
        <div class="d-flex align-items-center gap-2">
          <button class="btn btn-sm text-white p-0 border-0 bg-transparent" (click)="map.isOpen = !map.isOpen">
            <i class="pi" [ngClass]="map.isOpen ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
          </button>
          <span>{{ map.minimapConf.title }}</span>
        </div>
      </div>

      <div *ngIf="map.isOpen">
        <div class="col-12 d-flex flex-column g-3">
          <div class="col-12" *ngFor="let vehicle of map.minimapConf.vehicles; trackBy: trackByVehicle">
            <app-card-vehicle
              *ngIf="vehicle.unit"
              (setTrueVisible)="clickCard(map, vehicle)"
              [idCard]="'card-vehicle-' + vehicle.unit.device.IMEI"
              [IMEI]="vehicle.unit.device.IMEI"
              [primaryName]="vehicle.unit.unitName"
              [date]="vehicle.unit.device.trackerDate"
              [location]="vehicle.unit.device.SIMNumber"
              [transmissionStatus]="vehicle.unit.transmissionStatusId"
              [speed]="{ value: vehicle.unit.device.speed || 0, measurement: 'km/h' }"
              [batteryVoltage]="{ value: vehicle.unit.device.batteryVoltage || 0, measurement: 'V' }"
              [amountOfFuel]="{ value: vehicle.unit.device.IOs.can_dist || 0, measurement: 'gal' }"
              [hasIgnition]="vehicle.unit.hasIgnition"
              [timeElapsed]="convertSecondsToTimeString(vehicle.unit.elapsedTime)"
              [satelliteCount]="vehicle.unit.device.satelliteCount"
              [secondInformation]="''"
              [unitType]="vehicle.unit.unitType"
              [urlIcon]="vehicle.unit.tramsmissionIcon"
              [withOpenClose]="false"
              [withActionButton]="false"
            ></app-card-vehicle>
          </div>
          <div *ngIf="map.minimapConf.vehicles.length === 0" class="col-12 text-center text-muted py-3">
            <i class="pi pi-info-circle me-2"></i>
            No hay alertas registradas en este grupo.
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
